import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import './index.css';
import Navigator from './components/Navigator'
import Home from './pages/Home';
import NotFound from './pages/NotFound'
import Join from './pages/Join';
import ScrollToTop from './components/ScrollToTop';
import Beliefs from './pages/whoweare/Beliefs';
import Leaders from './pages/whoweare/Leaders';
import Ministries from './pages/grow/Ministries';
import Sermons from './pages/Sermons'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
    <ScrollToTop/>
        <Routes>
            <Route path="/" element={<Navigator/>}>
                <Route index element={<Home/>}/>
                <Route path='join' element={<Join/>}/>
                <Route path='leaders' element={<Leaders/>}/>
                <Route path='beliefs' element={<Beliefs/>}/>
                <Route path='ministries' element={<Ministries/>}/>
                <Route path='sermons' element={<Sermons/>}/>
                <Route path="*" element={<NotFound/>}/>
            </Route>
        </Routes>
    </BrowserRouter>
);
